/* product-fw-clip — "Seen in a Refind video" on the product page.

   Reverse Firework lookup: mounts a <fw-storyblock skus="…"> that surfaces a clip
   featuring THIS product (see FIREWORK.md §Product-page reverse lookup). The
   forward flow tags products onto videos in the Firework dashboard; this reads
   that association the other way.

   Behaviour: one pop-out on every breakpoint. mode="pinned" makes Firework float
   the player to the bottom-right corner as its body-level `#fw-player` singleton
   (portaled OUT of this <fw-storyblock> — confirmed in DevTools), dismissible by
   the visitor.

   No hide-when-empty logic, by construction: our mount in the product column is
   empty and invisible, and Firework only creates `#fw-player` when the `skus`
   feed matches — so products with no clip simply show nothing. (An earlier version
   ported rl-fw-fallback.js's shadow-root detection, but that assumes the player
   renders IN PLACE; a pinned storyblock relocates it to `#fw-player` on
   document.body, so `sb.shadowRoot` was the wrong ground truth. Deleted.)

   Firework's native Shop panel provides the one-tap skip-to-product-moment (the
   reverse "jump to timestamp" is Firework-side; we don't seek). */

(function () {
  var SDK_SRC = '//asset.fwcdn3.com/js/fwn.js';

  // fwn.js loads once. Note it ships on every PDP carrying the block (i.e. all of
  // them) — we can't know server-side whether a clip matches without asking
  // Firework. Tighter scoping (a `has-firework-clip` tag gate) is noted as a
  // future optimisation in FIREWORK.md. Same flag as sections/refind-live-hero.liquid.
  function loadSdk() {
    if (window.__fwnLoaded) return;
    window.__fwnLoaded = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = SDK_SRC;
    document.head.appendChild(s);
  }

  function build(mount) {
    if (mount.__fwClipBuilt) return;
    mount.__fwClipBuilt = true;

    var channel = mount.getAttribute('data-channel');
    var skus = mount.getAttribute('data-skus');
    if (!channel || !skus) return; // nothing to match on -> mount nothing

    var designMode = mount.getAttribute('data-design-mode') === 'true';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // A pinned storyblock that auto-floats to the bottom-right corner as a
    // dismissible pop-out — mode="pinned" + player_placement ARE the pop-out;
    // reset_transform keeps `#fw-player` fixed under the theme's transformed ancestors.
    var sb = document.createElement('fw-storyblock');
    sb.setAttribute('mode', 'pinned');
    sb.setAttribute('channel', channel);
    sb.setAttribute('skus', skus);                 // the reverse-lookup filter
    sb.setAttribute('max_videos', mount.getAttribute('data-max-videos') || '1');
    sb.setAttribute('player_placement', 'bottom-right');
    sb.setAttribute('reset_transform', 'always');
    sb.setAttribute('muted', 'true');              // the pop-out is silent
    // Reduced-motion (and the theme editor) still pop out, but don't auto-play —
    // the visitor presses play. Everyone else gets the muted auto-preview.
    if (reduceMotion || designMode) sb.setAttribute('autoplay', 'false');

    mount.appendChild(sb);
    loadSdk();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-fw-clip]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: build when the product section (re)loads. Firework reuses its
  // single `#fw-player`, so re-renders don't stack visible players.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
